module.exports = __webpack_public_path__ + "static/notserk_logo-9aac35ef42fd696fcb6d9aebfd01a3fa.png";